import React, { useState, useEffect } from 'react'
import { connect, useSelector } from "react-redux";
import {respondToInvoice, clearInvoice} from "../../../actions/invoices";

export function InvoiceStep3Rejected(props) {

const invoice = useSelector( (state) => state.invoices.invoice );

const handleSubmit = (e, response) => {
    e.preventDefault();
    if (response === "cancel") {
        props.handleResponseSubmit({ stage: "CA" }, "Invoice canceled");
        // props.respondToInvoice(invoice.invoice_id, { stage: "CA" }, "Invoice canceled");
    }
    if (response === "revise") {
        // push to editor
        props.handleReroute(`/mng/invoice/revise/${invoice.invoice_id}`);
        // in editor, use global invoice state version >1 ? to set elements of editor: 
            // no save button (for now. in future, save button exists but triggers different action)
            // project name, contract, invoice number: swithc from inputs to plain text. after number, put Version X
            // header: instead of "Draft" put "Revision: Version X"
    }
}

useEffect(() => {
    if(invoice.invoice_status === "Cancelled") {
        props.clearInvoice();
        props.handleReroute(`/mng/invoices/all`);
    }
}, [invoice.invoice_status]);



    return (
        <>
            <div className="content2 light-black multiline gap-above-xxs">
                If you believe this invoice was wrongfully rejected, you can push this matter to 
                <button id="invoice_adj" className="link2 heavy iblock" onClick={() => props.setRejModalOpen(true)}>&nbsp; Adjudication.</button>
            </div>
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="gap-above-m flex-row">
                    <button id="invoice_revise" className="btn pri min-width gap-right-s" type="submit" disabled={props.isSubmitting} onClick={(e) => handleSubmit(e, "revise")}>Revise Invoice</button>
                    <button id="invoice_cancel" className="btn sec min-width" disabled={props.isSubmitting} onClick={(e) => handleSubmit(e, "cancel")} >{props.isSubmitting ? "Please wait..." : "Cancel Invoice"}</button>
                </div>
            </form> 
        </>
    )
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {respondToInvoice, clearInvoice})(InvoiceStep3Rejected);

/*


Remove From Store
    - 
Update Store Price
Add To Store
Finish Store Inputs
Issue / Question
Active
Future
Past




*/